// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDateTime-Container_cls1__bbtcn","cls2":"VeloDateTime-Container_cls2__ysLCy VeloDateTime-Container_cls1__bbtcn"};